/* src/app/features/limite-adicional/limite-adicional-pesquisa/limite-adicional-listagem/limite-adicional-listagem.component.scss */
.table-responsive {
  margin-top: 40px;
}
::ng-deep .popover-datas-limite {
  max-width: 240px;
}
::ng-deep .popover-datas-limite .popover-body {
  text-align: left;
}
/*# sourceMappingURL=limite-adicional-listagem.component.css.map */
